// `store {variant_group}` (aldoo-na/store/actions/variant-group.js) and the
// product search the member picker runs (`store {list_products}`).
import { api } from "aldoo-ra/API"

const storeAPI = api("store")

const call = async (payload) => {
  const res = await storeAPI({ variant_group: payload })
  if (res?.error) throw new Error(res.error)
  return res
}

export const loadProductGroup = (pid, language) => call({ op: "get", pid, language })
export const listGroups = (language) => call({ op: "groups", language })
export const listMembers = (gid) => call({ op: "members", gid })
export const createGroup = (group) => call({ op: "create", ...group })
export const setProductGroup = (pid, gid, value) => call({ op: "set", pid, gid, value })
export const addMembers = (gid, pids) => call({ op: "add", gid, pids })
export const removeMember = (pid) => call({ op: "remove", pid })

export const searchProducts = async (search) => {
  const res = await storeAPI({ list_products: { search, itemsPerPage: 24, page: 1 } })
  return Array.isArray(res?.data) ? res.data : []
}
